import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { IntegratedIReckonHotelDto } from '@rocksoft/integrations-ireckon-sdk';

export type IntegratedIReckonHotelState = EntityState<IntegratedIReckonHotelDto>;

export function selectIReckonIntegratedHotelIdFromHotel(hotel: IntegratedIReckonHotelDto) {
  return hotel.locationUniqueId;
}

export const adapter: EntityAdapter<IntegratedIReckonHotelDto> = createEntityAdapter<IntegratedIReckonHotelDto>({
  selectId: selectIReckonIntegratedHotelIdFromHotel,
});

export const initialState: IntegratedIReckonHotelState = adapter.getInitialState();
